import { render, staticRenderFns } from "./ConfigMwxKey.vue?vue&type=template&id=37cef853"
import script from "./ConfigMwxKey.vue?vue&type=script&lang=js"
export * from "./ConfigMwxKey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports